(()=>{
  const pad=n=>String(n).padStart(2,'0');
  const init=slider=>{
    if(slider.dataset.mmSliderReady)return;
    slider.dataset.mmSliderReady='true';

    const root=slider.closest('[data-product-root]');
    const slides=Array.from(slider.querySelectorAll('[data-product-media]'));
    const prev=slider.querySelector('[data-mm-slider-prev]');
    const next=slider.querySelector('[data-mm-slider-next]');
    const count=slider.querySelector('[data-mm-slider-count]');
    if(!slides.length)return;

    const variants=(()=>{try{return JSON.parse(root?.querySelector('[data-product-json]')?.textContent||'[]')}catch(e){return[]}})();
    const fieldsets=Array.from(root?.querySelectorAll('.variant-fieldset')||[]);
    const colourFieldset=root?.querySelector('.variant-fieldset--colour');
    const colourIndex=colourFieldset?fieldsets.indexOf(colourFieldset):-1;
    const variantSelect=root?.querySelector('[data-variant-select]');
    const price=root?.querySelector('[data-product-price]');
    const add=root?.querySelector('[data-add-button]');

    const mediaIdOf=variant=>variant?.featured_media?.id||variant?.featured_image?.id||null;
    const mediaColour=new Map();
    if(colourIndex>=0){
      variants.forEach(variant=>{
        const mediaId=mediaIdOf(variant);
        const colour=variant?.options?.[colourIndex];
        if(mediaId&&colour)mediaColour.set(String(mediaId),colour);
      });
    }

    const colourForSlide=slideIndex=>{
      if(colourIndex<0)return null;
      const direct=mediaColour.get(String(slides[slideIndex]?.dataset.mediaId||''));
      if(direct)return direct;
      for(let distance=1;distance<slides.length;distance++){
        const before=slideIndex-distance;
        if(before>=0){
          const colour=mediaColour.get(String(slides[before]?.dataset.mediaId||''));
          if(colour)return colour;
        }
        const after=slideIndex+distance;
        if(after<slides.length){
          const colour=mediaColour.get(String(slides[after]?.dataset.mediaId||''));
          if(colour)return colour;
        }
      }
      return null;
    };

    const money=cents=>new Intl.NumberFormat(document.documentElement.lang||'en-GB',{
      style:'currency',currency:window.Shopify?.currency?.active||'GBP'
    }).format(Number(cents||0)/100);

    const syncVariantFromSlide=slideIndex=>{
      const colour=colourForSlide(slideIndex);
      if(!colour||!colourFieldset)return;
      const colourInput=Array.from(colourFieldset.querySelectorAll('input[type="radio"]')).find(input=>input.value===colour);
      if(!colourInput)return;
      colourInput.checked=true;

      const selectedValues=fieldsets.map(fieldset=>fieldset.querySelector('input[type="radio"]:checked')?.value);
      const variant=variants.find(v=>Array.isArray(v.options)&&v.options.every((value,i)=>selectedValues[i]===value));
      if(!variant)return;

      if(variantSelect)variantSelect.value=variant.id;
      if(price)price.textContent=money(variant.price);
      if(add){
        add.disabled=!variant.available;
        add.textContent=variant.available?'ADD TO BAG +':'SOLD OUT';
      }
    };

    let index=Math.max(0,slides.findIndex(slide=>!slide.hidden));
    const render=(i,syncVariant=true)=>{
      index=(i+slides.length)%slides.length;
      slides.forEach((slide,n)=>{
        slide.hidden=n!==index;
        slide.setAttribute('aria-hidden',n===index?'false':'true');
      });
      if(count)count.textContent=`${pad(index+1)} / ${pad(slides.length)}`;
      if(syncVariant)syncVariantFromSlide(index);
    };

    render(index,false);
    prev?.addEventListener('click',()=>render(index-1,true));
    next?.addEventListener('click',()=>render(index+1,true));

    let startX=null;
    slider.addEventListener('touchstart',e=>{startX=e.touches[0]?.clientX??null},{passive:true});
    slider.addEventListener('touchend',e=>{
      if(startX===null)return;
      const endX=e.changedTouches[0]?.clientX??startX;
      const delta=endX-startX;
      startX=null;
      if(Math.abs(delta)<45)return;
      render(delta<0?index+1:index-1,true);
    },{passive:true});

    root?.querySelectorAll('input[name^="options"]').forEach(input=>input.addEventListener('change',()=>requestAnimationFrame(()=>{
      const visible=slides.findIndex(slide=>!slide.hidden);
      if(visible>=0){
        index=visible;
        if(count)count.textContent=`${pad(index+1)} / ${pad(slides.length)}`;
      }
    })));
  };

  const boot=()=>document.querySelectorAll('[data-mm-product-slider]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();